import { useState } from 'react';

import { useResizeObserver } from './useResizeObserver';

export type UseMeasureWidthQueryParams = {
  minWidth?: number;
  maxWidth?: number;
};

export const useMeasureWidthQuery = <T extends HTMLElement = HTMLElement>({
  minWidth = 0,
  maxWidth,
}: UseMeasureWidthQueryParams) => {
  const [width, setWidth] = useState(0);
  const [isMatching, setIsMatching] = useState(false);

  const [ref] = useResizeObserver<T>({
    onResize: (rect) => {
      setWidth(rect.width);
      const isMinWidthMatching = rect.width >= minWidth;
      const isMaxWidthMatching = maxWidth ? rect.width <= maxWidth : true;

      const nextIsMatching = [isMinWidthMatching, isMaxWidthMatching].every(Boolean);

      if (nextIsMatching !== isMatching) {
        setIsMatching(nextIsMatching);
      }
    },
  });

  return [ref, { isMatching, width }] as const;
};
